import dagre from "dagre"

const NODE_W = 220
const NODE_H = 96

// Returns nodes with computed { x, y } positions for any node that didn't ship
// one (i.e. position was nil on the server). Existing positions are preserved.
export function autoLayout(nodes, edges) {
  const graph = new dagre.graphlib.Graph()
  graph.setGraph({ rankdir: "LR", nodesep: 40, ranksep: 80 })
  graph.setDefaultEdgeLabel(() => ({}))

  nodes.forEach(n => graph.setNode(n.id, { width: NODE_W, height: NODE_H }))
  edges.forEach(e => graph.setEdge(e.source, e.target))

  dagre.layout(graph)

  return nodes.map(n => {
    if (n.position && Number.isFinite(n.position.x) && Number.isFinite(n.position.y)) {
      return n
    }
    const laid = graph.node(n.id)
    return {
      ...n,
      position: { x: laid.x - NODE_W / 2, y: laid.y - NODE_H / 2 }
    }
  })
}
